export default "__VITE_ASSET__BtLPguSf__"